import React from "react";

const ButtonLoader = () => {
  return (
    <>
      <div className="spinner-border spinner-border-sm me-2" role="status"></div>{" "}
    </>
  );
};

export default ButtonLoader;
